import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import dayjs from "dayjs";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import SchwingLogo from "../../../Images/Machines/Batching plant.png";

const tableHeadings = [
  {
    bno: "Batch No",
    bdate: "Date",
    cid: "Batch Start Time",
    rid: "Batch End Time",
    qty: "Recipe Code",
    prd: "Prod. Quantity",
  },
];

const SiteReporot = ({ reportData }) => {
  const [pdfUrlCh, setPdfUrlCh] = useState(null);

  const [from, setFrom] = useState(dayjs());
  const [to, setTo] = useState(dayjs());
  //   const handleDownloadExcel = () => {
  //     // Define the data to include in the Excel file
  //     const worksheetData = [];

  //     // Add the company header
  //     worksheetData.push(
  //       ["Company Name"],
  //       ["Site Report"],
  //       [
  //         `Plant SI No.: ${reportData.plant_sl}`,
  //         "",
  //         "",
  //         "",
  //         `From Date: ${dayjs(from).format("YYYY-MM-DD")}`,
  //       ],
  //       [
  //         `Plant Name: ${reportData.plant_type}`,
  //         "",
  //         "",
  //         "",
  //         `To Date: ${dayjs(to).format("YYYY-MM-DD")}`,
  //       ],
  //       [] // Add an empty row
  //     );

  //     // Loop through each customer and add their data
  //     reportData.data.forEach((customer) => {
  //       // Add customer header
  //       worksheetData.push(
  //         [`Customer Name: ${customer.cust_name}`],
  //         [] // Add an empty row for separation
  //       );

  //       // Add column headers for batch data
  //       worksheetData.push([
  //         "Batch No.",
  //         "Date",
  //         "Batch Start Time",
  //         "Batch End Time",
  //         "Recipe Code",
  //         "Prod. Quantity",
  //       ]);

  //       // Add batch data
  //       customer.data.forEach((item) => {
  //         worksheetData.push([
  //           item.batch_no,
  //           item.batch_date,
  //           item.st,
  //           item.et,
  //           item.recipe_id,
  //           item.prod_qty,
  //         ]);
  //       });

  //       // Add an empty row after each customer's data
  //       worksheetData.push([]);
  //     });

  //     // Create a worksheet from the data
  //     const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  //     // Merge cells for styling the header
  //     worksheet["!merges"] = [
  //       { s: { r: 0, c: 0 }, e: { r: 0, c: 4 } }, // Merge company name
  //       { s: { r: 1, c: 0 }, e: { r: 1, c: 4 } }, // Merge report title
  //     ];

  //     // Create a workbook and append the worksheet
  //     const workbook = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(workbook, worksheet, "Site Report");

  //     // Write the workbook and trigger download
  //     const excelBuffer = XLSX.write(workbook, {
  //       bookType: "xlsx",
  //       type: "array",
  //     });

  //     // Download the Excel file
  //     const data = new Blob([excelBuffer], { type: "application/octet-stream" });
  //     saveAs(data, `Customer_Report_${reportData.plant_type}.xlsx`);
  //   };

  let CustomerLogo;
  let logo, drawWidth, drawHeight; // Define these variables at a higher scope

  //   if (sessionStorage.getItem("logo") === "1") {
  //     if (userId === "L1976") {
  //       CustomerLogo = `${process.env.PUBLIC_URL}/CustomerLogo/C1991_0.jpeg`;
  //     } else if (userId === "L1709") {
  //       CustomerLogo = `${process.env.PUBLIC_URL}/CustomerLogo/C1706_0.jpeg`;
  //     }
  //   }

  async function handleGeneratePDF() {
    const pdfDoc = await PDFDocument.create();
    const fontSize = 8.5;
    const pageWidth = 595;
    const pageHeight = 842;
    const title = "    Elantris Private Limited";

    const fromDate = dayjs(from).format("DD-MM-YYYY");
    const toDate = dayjs(to).format("DD-MM-YYYY");

    const MainData = [];
    const data = [];
    for (let j in reportData.data) {
      MainData.push(reportData.data[j]);
      for (let k in MainData[j].data) {
        data.push(MainData[j].data[k]);
      }
    }

    //console.log(MainData);

    const x = 30;
    const y = pageHeight - (tableHeadings.length - 2) * fontSize;

    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const pageCount = Math.ceil(data.length / 15);
    let rowY = pageHeight - (tableHeadings.length - 2) * fontSize;
    let rowY2 = y;
    let rowY3 = y;
    const imageBytes = await fetch(SchwingLogo).then((res) =>
      res.arrayBuffer()
    );

    const image = await pdfDoc.embedPng(imageBytes);
    if (CustomerLogo) {
      const imageBytes2 = await fetch(CustomerLogo).then((res) =>
        res.arrayBuffer()
      );
      let imageWidth, imageHeight;

      if (CustomerLogo.endsWith(".png")) {
        logo = await pdfDoc.embedPng(imageBytes2);
        const pngDims = logo.scale(1); // Get the natural size
        imageWidth = pngDims.width;
        imageHeight = pngDims.height;
      } else if (
        CustomerLogo.endsWith(".jpeg") ||
        CustomerLogo.endsWith(".jpg")
      ) {
        logo = await pdfDoc.embedJpg(imageBytes2);
        const jpgDims = logo.scale(1); // Get the natural size
        imageWidth = jpgDims.width;
        imageHeight = jpgDims.height;
      } else {
        throw new Error("The input is not a PNG or JPG file!");
      }
      const targetWidth = 110;
      const targetHeight = 75;

      const aspectRatio = imageWidth / imageHeight;

      if (imageWidth > imageHeight) {
        // Wider than tall
        drawWidth = targetWidth;
        drawHeight = targetWidth / aspectRatio;
      } else {
        // Taller than wide or square
        drawHeight = targetHeight;
        drawWidth = targetHeight * aspectRatio;
      }
    }
    MainData.forEach((value) => {
      for (let i = 0; i < pageCount; i++) {
        const startIndex = i * 27;
        const endIndex = Math.min(startIndex + 27, data.length);
        const pageData = value.data.slice(startIndex, endIndex);

        if (pageData.length > 0) {
          rowY2 = 650;
          let page = pdfDoc.addPage([pageWidth, pageHeight]);
          let pageRowY = rowY2 + 12;

          for (const element of pageData) {
            page.drawText(element.batch_no.toString(), {
              x: x + 15,
              y: pageRowY,
              font,
              size: fontSize,
            });
            page.drawText(element.batch_date.toString(), {
              x: x + 75,
              y: pageRowY,
              font,
              size: fontSize,
            });
            page.drawText(element.st.toString(), {
              x: x + 160,
              y: pageRowY,
              font,
              size: fontSize,
            });

            page.drawText(element.et.toString(), {
              x: x + 254,
              y: pageRowY,
              font,
              size: fontSize,
            });

            page.drawText(element.recipe_id.toString(), {
              x: x + 350,
              y: pageRowY,
              font,
              size: fontSize,
            });
            page.drawText(element.prod_qty.toString(), {
              x: x + 491,
              y: pageRowY,
              font,
              size: fontSize,
            });
            pageRowY -= 24;
          }
          page.drawText("Total Production Detail Site wise", {
            x: 188,
            y: 775,
            size: 13,
            font,
          });
          page.drawText("Plant Sl No.:", {
            x: 50,
            y: 757,
            size: 12,
            font,
          });
          page.drawText(reportData.plant_sl, {
            x: 130,
            y: 757,
            size: 12,
            font,
          });
          page.drawText("Plant Name:", {
            x: 50,
            y: 740,
            size: 12,
            font,
          });
          page.drawText(reportData.plant_type, {
            x: 130,
            y: 740,
            size: 12,
            font,
          });
          page.drawText("From Time:", {
            x: 400,
            y: 757,
            size: 12,
            font,
          });
          page.drawText(fromDate.toString(), {
            x: 470,
            y: 757,
            size: 12,
            font,
          });
          page.drawText("To Time:", {
            x: 400,
            y: 740,
            size: 12,
            font,
          });
          page.drawText(toDate.toString(), {
            x: 470,
            y: 740,
            size: 12,
            font,
          });
          tableHeadings &&
            tableHeadings.forEach((header, rowIndex) => {
              rowY3 = y - (rowIndex + 20) * fontSize;
              rowY = y - (rowIndex + 16.2) * fontSize;

              page.drawText(value.cust_name.toString(), {
                x: x + 95,
                y: rowY,
                font,
                size: fontSize + 3,
              });

              page.drawText(value.site.toString(), {
                x: x + 470,
                y: rowY,
                font,
                size: fontSize + 3,
              });
              page.drawText("Customer Name : ", {
                x: x,
                y: rowY,
                font,
                size: fontSize + 3,
              });

              page.drawText("Site Name : ", {
                x: x + 400,
                y: rowY,
                font,
                size: fontSize + 3,
              });

              page.drawText(header.bno.toString(), {
                x: x + 8,
                y: rowY3,
                font,
                size: fontSize + 2,
              });
              page.drawText(header.bdate.toString(), {
                x: x + 83,
                y: rowY3,
                font,
                size: fontSize + 2,
              });
              page.drawText(header.cid.toString(), {
                x: x + 145,
                y: rowY3,
                font,
                size: fontSize + 2,
              });
              page.drawText(header.rid.toString(), {
                x: x + 243,
                y: rowY3,
                font,
                size: fontSize + 2,
              });
              page.drawText(header.qty.toString(), {
                x: x + 358,
                y: rowY3,
                font,
                size: fontSize + 2,
              });
              page.drawText(header.prd.toString(), {
                x: x + 466,
                y: rowY3,
                font,
                size: fontSize + 2,
              });
            });

          page.drawText(title, {
            x: 170,
            y: 800,
            size: 18,
            font,
          });

          page.drawImage(image, {
            x: 20,
            y: 800,
            width: 100,
            height: 30,
          });
          if (sessionStorage.getItem("logo") === "1" && logo) {
            page.drawImage(logo, {
              x: 490,
              y: 770,
              width: drawWidth,
              height: drawHeight,
            });
          }
          page.drawLine({
            start: { x: 90, y: pageRowY + 18 },
            end: { x: 90, y: rowY3 + 13.5 },
            thickness: 0.1,
            color: rgb(0.5, 0.5, 0.5),
            opacity: 0.75,
          });
          page.drawLine({
            start: { x: 165, y: pageRowY + 18 },
            end: { x: 165, y: rowY3 + 13.5 },
            thickness: 0.1,
            color: rgb(0.5, 0.5, 0.5),
            opacity: 0.75,
          });
          page.drawLine({
            start: { x: 262, y: pageRowY + 18 },
            end: { x: 262, y: rowY3 + 13.5 },
            thickness: 0.1,
            color: rgb(0.5, 0.5, 0.5),
            opacity: 0.75,
          });
          page.drawLine({
            start: { x: 355, y: pageRowY + 18 },
            end: { x: 355, y: rowY3 + 13.5 },
            thickness: 0.1,
            color: rgb(0.5, 0.5, 0.5),
            opacity: 0.75,
          });

          page.drawLine({
            start: { x: 490, y: pageRowY + 18 },
            end: { x: 490, y: rowY3 + 13.5 },
            thickness: 0.1,
            color: rgb(0.5, 0.5, 0.5),
            opacity: 0.75,
          });
          page.drawLine({
            start: { x: 25, y: rowY3 - 5 },
            end: { x: 570, y: rowY3 - 5 },
            thickness: 1,
            color: rgb(0.5, 0.5, 0.5),
            opacity: 0.75,
          });
          page.drawLine({
            start: { x: 25, y: rowY3 + 13 },
            end: { x: 570, y: rowY3 + 13 },
            thickness: 1,
            color: rgb(0.5, 0.5, 0.5),
            opacity: 0.75,
          });
          page.drawLine({
            start: { x: 570, y: rowY3 + 13.5 },
            end: { x: 570, y: pageRowY + 18 },
            thickness: 1,
            color: rgb(0.5, 0.5, 0.5),
            opacity: 0.75,
          });
          page.drawLine({
            start: { x: 25, y: rowY3 + 13.5 },
            end: { x: 25, y: pageRowY + 18 },
            thickness: 1,
            color: rgb(0.5, 0.5, 0.5),
            opacity: 0.75,
          });
          page.drawLine({
            start: { x: 25, y: pageRowY + 18 },
            end: { x: 570, y: pageRowY + 18 },
            thickness: 1,
            color: rgb(0.5, 0.5, 0.5),
            opacity: 0.75,
          });
        }
      }
    });

    // Save the PDF
    const pdfBytes = await pdfDoc.save();

    setPdfUrlCh(
      URL.createObjectURL(new Blob([pdfBytes], { type: "application/pdf" }))
    );
  }

  //   async function handleDownloadPDF() {
  //     const link = document.createElement("a");
  //     link.href = pdfUrl;
  //     link.download = "Schwing_DMM_Customer.pdf";
  //     link.textContent = "Schwing_DMM_Customer";
  //     link.click();
  //   }

  // useEffect(() => {
  //   dispatch(fetchPlants());
  // }, []);

  useEffect(() => {
    handleGeneratePDF(); // Safe to call only when data is available
  }, []);

  return (
    <Grid container spacing={2} alignItems='center'>
      <iframe
        src={pdfUrlCh}
        width='100%'
        height='600px'
        title='Batch Report PDF'
      />
    </Grid>
  );
};

export default SiteReporot;
